/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_TitleInputs */

const da_forside_title = /** @type {(inputs: Forside_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om AImforA`)
};

/** @type {(inputs: Forside_TitleInputs) => LocalizedString} */
const en_forside_title = da_forside_title;

/**

* @param {Forside_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_title = /** @type {((inputs?: Forside_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_title(inputs)
	return /** @type {LocalizedString} */ ("Om AImforA")
});